import React from 'react'

const LayerSearchBar = ({ searchTerm, handleSearch, onClear }) => {
    return (
        <div className="windy-style-search">
            <div className="windy-style-search-icon">
                <i className="fa-solid fa-search"></i>
            </div>
            <input
                type="text"
                className="windy-style-search-input"
                placeholder="Search layers"
                value={searchTerm}
                onChange={handleSearch}
            />
            {
                searchTerm && (
                    <div
                        className="windy-style-search-clear"
                        onClick={onClear}
                    >
                        <i className="fa-solid fa-times" />
                    </div>
                )
            }
        </div>
    )
}

export default LayerSearchBar;